<!-- eslint-disable max-len -->
<template>
  <div>
    <div
      v-if="!isLoading"
      class="wrap-title-component"
    >
      {{ titleComponent }}
    </div>
    <h5
      v-if="!isLoading"
      class="mb-2"
    >
      {{ titleView }}
    </h5>

    <div
      v-if="!isLoading"
    >
      <b-row>
        <!-- Field -->
        <b-col :cols="detailComponent.is_pagescreen ? 8 : 12">

          <div class="wrap-field no-gutters">
            <div
              v-for="column in detailComponent.columns"
              :key="column.field_ui_key"
              :class="`col-md-${column.grid_size ? column.grid_size : 12}`"
              style="padding-right: 10px;"
            >
              <div
                class="field-list dummy hover-none"
                style="cursor: default;"
              >
                <p class="column-name">{{ column.name }}</p>

                <field-preview
                  :column="column"
                  :use-drag-icon="false"
                />
              </div>
            </div>
          </div>
        </b-col>

        <!-- Action Button -->
        <b-col
          v-if="detailComponent.is_pagescreen && type !== 'create'"
          cols="4"
        >
          <h5>Action Button</h5>

          <div
            v-for="button in detailComponent.action_buttons"
            :key="button.key"
            class="action-button-list hover-none"
          >
            <i
              :class="`icon-button fa ${button.icon_web.includes('fa-') ? button.icon_web : 'fa-' + button.icon_web}`"
            />
            {{ button.label }}
          </div>
        </b-col>
      </b-row>
    </div>

    <div
      v-else
      class="skeleton-component"
    />
  </div>
</template>

<script>
/* eslint-disable max-len */
import jMixComponentMultiDetailView from '@/mixins/form-ui-v2/jMixComponentMultiDetailView';
import FieldPreview from '@/views/experience-manager-v2/partials/FieldPreview';

export default {
  components: {
    FieldPreview,
  },

  mixins: [jMixComponentMultiDetailView],

  props: {
    type: {
      type: String,
      default: '',
    },
    forDetailParent: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    async getDetailComponent() {
      const response = await this.requestDataComponent();
      if (response) {
        this.detailComponent = this.type === 'detail' ? response.data.data[0].detail_view : response.data.data[0].create_view;
        this.titleView = this.detailComponent.title;
        this.isLoading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dummy/DummyCreateDetailView.vue